﻿import React, { useEffect } from 'react';

const LOGIN_KEY = 'user_login_time';
const SESSION_DURATION = 24 * 60 * 60 * 1000; // 24 horas em milissegundos

const SessionTimeout = ({ children }) => {
  useEffect(() => {
    const checkSession = () => {
      // Verificar se está nas rotas públicas
      if (window.location.pathname === '/qr_consulta' || window.location.pathname === '/motorista-temp') {
        return; // Não verificar autenticação para rotas públicas
      }

      const loginTime = localStorage.getItem(LOGIN_KEY);
      const token = localStorage.getItem('token');
      if (!token || !loginTime) {
        if (window.location.pathname !== '/login') {
          window.location.href = `${window.location.origin}/login`;
        }
        return;
      }

      const currentTime = Date.now();
      const timeElapsed = currentTime - parseInt(loginTime, 10);
      if (timeElapsed > SESSION_DURATION) {
        localStorage.clear();
        if (window.location.pathname !== '/login') {
          window.location.href = `${window.location.origin}/login`;
        }
      }
    };

    //checkSession();

    const interval = setInterval(checkSession, 1000 * 60); // Verifica a cada minuto


    return () => clearInterval(interval);
  }, []);

  return <>{children}</>;
};

export default SessionTimeout;
